import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck, faCircleStop, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { MilestoneStatusResponses, MilestoneTypes } from '../../models';
import { CerebroIcon } from '../CerebroIcon';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';

interface MilestoneIconProps {
	size: number;
	inProgress: boolean;
	type: MilestoneTypes;
	response?: MilestoneStatusResponses;
}

export const MilestoneIcon: React.FC<MilestoneIconProps> = ({ size, inProgress, type, response }) => {
	const callInProgress = type == 'ReadyForCall' && inProgress;
	const faIcon = callInProgress
		? faCalendarDays
		: response == 'Yes'
		? faSquareCheck
		: response == 'OptOut'
		? faCircleStop
		: faSquare;
	const faSize = size == 2 ? ('lg' as SizeProp) : ('md' as SizeProp);
	const faColor = callInProgress
		? '#31708f'
		: response == 'Yes'
		? '#548235'
		: response == 'OptOut'
		? '#A94442'
		: '#75767A';

	return (
		<CerebroIcon sx={{ color: faColor, marginLeft: 1 }}>
			<FontAwesomeIcon icon={faIcon} size={faSize} />
		</CerebroIcon>
	);
};
